export const ENUM_SCORES = {
  ILLUSTRATION_MINT: process.env.REACT_APP_ILLUSTRATION_MINT_SCORE,
  TOKEN_DISTRIBUTION: process.env.REACT_APP_TOKEN_DISTRIBUTION_SCORE,
  CROWN: process.env.REACT_APP_CROWN_SCORE,
  GANGSTABET_SCORE: process.env.REACT_APP_GANGSTABET_SCORE,
  ICON_TRACKER: "https://tracker.icon.community/transaction"
};
